// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__29nGj","label":"Completed_label__flzuO"};